module.exports = __webpack_public_path__ + "media/52.7c26fb25.mp3";